import { Colors, Text } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { ProficiencyLegendItem } from './ProficiencyLegendItem';

export interface SkillsetLegendEntry {
    id: string;
    label: string;
    iconName?: string;
    iconUrl?: string;
    iconColor?: string;
}

interface SkillsetProficiencyLegendProps {
    entries: SkillsetLegendEntry[];
    isLoading: boolean;
}

/** The company's mastery scale, read under the card. A scale still being loaded says so rather
 * than reading as a company that declared none. */
export const SkillsetProficiencyLegend = ({
    entries,
    isLoading,
}: SkillsetProficiencyLegendProps) => {
    const { t } = useTranslation();

    const renderContent = () => {
        if (isLoading) {
            return (
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                >
                    {t('performanceProfile.skillsetAssessment.proficiencyLevels.loading')}
                </Text>
            );
        }

        if (entries.length === 0) {
            return (
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                >
                    {t('performanceProfile.skillsetAssessment.proficiencyLevels.noLevelFound')}
                </Text>
            );
        }

        return entries.map((entry) => (
            <ProficiencyLegendItem
                key={entry.id}
                iconUrl={entry.iconUrl}
                iconName={entry.iconName}
                iconColor={entry.iconColor}
                label={entry.label}
            />
        ));
    };

    return (
        <div className={'border-growth-line mt-5 items-center gap-2'}>
            <Text
                weight={'semibold'}
                size={'small'}
                className={'text-navy ds-mb-sm text-[12px] leading-none'}
            >
                {t('performanceProfile.skillsetAssessment.proficiencyLevels.title')}
            </Text>

            <div className={'gap-gap-md flex flex-wrap'}>{renderContent()}</div>
        </div>
    );
};
